import { FC } from 'react';
// components
import AccessDenied from 'components/AccessDenied';
// helper, interfaces, context
import { isAdminOrSuperAdminOrStaff } from 'lib/helper';
import { ChildrenType } from 'interfaces';
import { useAuthContext } from 'contexts/AuthContext';

export const SuperOrAdminOrStaffGuard: FC<ChildrenType> = ({ children }) => {
  const { userRoles } = useAuthContext();

  const isSuperAndAdminAndStaff = isAdminOrSuperAdminOrStaff(userRoles);

  return <>{isSuperAndAdminAndStaff ? children : <AccessDenied />}</>;
};
